import React from "react";
import {TableButton} from "./TableButton";
import HttpRequest from "../../../../../Common/Http/HttpRequest";
import Notify from "../../../../../Common/Notify/Notify";
import Dialog from "../../../../../Common/Notify/Dialog";

export const DeleteButton = ({row, updateTable, deleteEndpoint}) => {

    const doDelete = () => {
        Dialog.confirmAction('Deseja remover a entidade?', 'Remover?').then(() => {
            const url = `${deleteEndpoint}/${row.original.id}`
            HttpRequest.delete(url).then(x => {
                updateTable();
                Notify.success('Entidade removida!');
            }).catch(e => {
                Notify.error('Falha ao remover entidade', e);
            })
        }).catch(() => {
        });
    }

    return (<TableButton className="btn-danger bg-danger" onClick={doDelete} title="Remover/Deletar registro">
            <i className="fa fa-trash" aria-hidden="true"></i>
        </TableButton>
    )
}
